import { mockBasicInfo } from "./basic-info.mocks";
import { rest } from "msw";
export const basicInfoHandlers = [
    rest.get("/search/options", (req, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockBasicInfo));
    }),
];
